import React, { memo } from "react";
import { EColors } from "../ZColors/interface";
import {
	IIconProps,
	ESizeMaps,
	EIcons,
	ETwoToneIcons,
	IllustrationDimensions
} from "./interface";
import styles from "./index.module.less";
import IconsSprite from "config/assets/IconsSprite.svg";
import TwoToneIconSprite from "config/assets/TwoToneIconsSprite.svg";
import IllustrationsSprite from "config/assets/IllustrationsSprite.svg";

const ZIcon: React.FC<IIconProps> = ({
	name = "",
	color = EColors.GRAY,
	colorVariant = 9,
	fill = false,
	fillstrokesame = true,
	fillColor = EColors.GRAY,
	fillColorVariant = 1,
	size = "md",
	className = "",
	isTwoToneIcon = false,
	middleAlign = true,
	onClick,
	hex,
	isIllustration = false,
	...rest
}) => {
	if (isTwoToneIcon) {
		return (
			<svg
				width={ESizeMaps[size]}
				height={ESizeMaps[size]}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				className={`${className} ${middleAlign && "align-middle"}`}
				onClick={onClick}
				{...rest}
			>
				<use href={TwoToneIconSprite + `#${name}`} />
			</svg>
		);
	}

	if (isIllustration) {
		return (
			<svg
				width={IllustrationDimensions[name].width}
				height={IllustrationDimensions[name].height}
				className={`${className} ${middleAlign && "align-middle"}`}
			>
				<use href={IllustrationsSprite + `#${name}`} />
			</svg>
		);
	}

	return (
		<svg
			width={ESizeMaps[size]}
			height={ESizeMaps[size]}
			className={`${className} ${
				fill
					? fillstrokesame
						? styles[
								`color-fill-stroke-same-${color}-${colorVariant}`
						  ]
						: styles[`color-fill-${fillColor}-${fillColorVariant}`]
					: styles["color-fill-transparent-1"]
			} ${styles[`color-${color}-${colorVariant}`]} ${
				middleAlign ? "align-middle" : ""
			}`}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			onClick={onClick}
			stroke={hex ?? ""}
			{...rest}
		>
			<use href={IconsSprite + `#${name}`} />
		</svg>
	);
};

export { EIcons as Icons };
export { ETwoToneIcons as TwoToneIcons };

export default memo(ZIcon);
